import React, { createContext, useState } from "react";

export const SelectedRFPContext = createContext(); 

export const SelectedRFPProvider = ({ children }) => {
    const [selectedRFP, setSelectedRFP] = useState(null);

  return (
    <SelectedRFPContext.Provider value={{ selectedRFP, setSelectedRFP }}>
      {children} 
    </SelectedRFPContext.Provider>
  );
};
